import React from "react";
import * as actions from '../Actions';

export default function DietPlanSlider({ eleRef, Slidedata, tool }) {
    return (
        <div className="slider-cont">
            <div className="month-slider">
                <ul>
                    {Slidedata && Slidedata.length > 0 && Slidedata.map((stage, index) => ((stage['stageId'] <= 19 && tool == "bd") || (tool == "md")) ?
                        (
                            !global.ftk && stage['stageId'] == 1 ? (
                                <li key={index} className={'tablink act' + index} id={'id_' + stage['stageId']} rel={index} onClick={(e) => { eleRef.tablink(e, stage['stageId']) }} >
                                    {/* <a> */}
                                    <div className="month-slider-list">
                                        <div className="baby-month-image">
                                            <img src={stage['stageImage']} className="cardslider" alt={stage['stageId'] + ' Month Pregnant Mom Icon'} title={stage['stageId'] + ' Month Pregnant Mom Icon'} />
                                        </div>
                                        <span className="month-old R14_9e">{stage['stageName']}</span>
                                    </div>
                                    {/* </a> */}
                                </li>
                            ) :

                                (
                                    global.ftk != '' && stage['stageId'] == eleRef.state.currentStageId) ?
                                    (<li key={index} className={'tablink act' + index} id={'id_' + stage['stageId']} rel={index} onClick={(e) => { eleRef.tablink(e, stage['stageId']) }}>
                                        <div className="month-slider-list">
                                            <div className="baby-month-image">
                                                {/* {`${stage['stageImage']}`.replace(/\.jpg$/i, ".webp")} */}
                                                <img src={stage['stageImage']} className="cardslider" alt={stage['stageId'] + ' Month Pregnant Mom Icon'} title={stage['stageId'] + ' Month Pregnant Mom Icon'} />
                                            </div>
                                            <span className="month-old R14_9e">{stage['stageName']}</span>
                                        </div>
                                    </li>
                                    ) : (
                                        <li key={index} className={'tablink act' + index} id={'id_' + stage['stageId']} rel={index} onClick={(e) => { eleRef.tablink(e, stage['stageId']) }}>
                                            <div className="month-slider-list">
                                                <div className="baby-month-image">
                                                    <img src={stage['stageImage']} className="cardslider" alt={stage['stageId'] + ' Month Pregnant Mom Icon'} title={stage['stageId'] + ' Month Pregnant Mom Icon'} />
                                                </div>
                                                <span className="month-old R14_9e">{stage['stageName']}</span>
                                            </div>
                                        </li>
                                    )
                        ) : null

                    )}
                </ul>

                <div className="arrows">
                    <span className="next" onClick={(e) => { actions.slideStage(e,eleRef) }}>
                        <span data-icon-font="h" className="icon"></span>
                    </span>
                    <span className="prev" onClick={(e) => { actions.slideStage(e,eleRef) }}>
                        <span data-icon-font="g" className="icon"></span>
                    </span>
                </div>
            </div>
        </div>
    );
}
